// This is just an example,
// so you can safely delete all default props below

export default {
    back: 'Tilbake',
    contents: 'Innhold',
    create: 'Lag ny',
    name: 'Innhold navn'
}
